<!--
 * @Author: M.D.
 * @Date: 2019-12-18 10:50:19
 * @LastEditors  : M.D.
 * @Description:
 * @Remarks:
 -->
<template>
  <div class="my-point">
    <!-- 用户信息 -->
    <div class="upper bShadow-5">
      <div class="uc-img">
        <div class="uc-img-w bShadow-10">
          <img :src="tImgUrl(userInfo.avatar)" :onerror="errImgDefault" style="width:100%; height:100%" />
        </div>
      </div>
      <div class="info">
        <div class="point">我的积分：<span class="num">{{point}}</span>分</div>
      </div>
      <div class="btn">
        <el-button type="success" round @click="pointDetail = true">积分明细</el-button>
        <el-button type="success" class="rules" round plain @click="agShow = true">积分规则</el-button>
      </div>
    </div>

    <!-- 积分商品 -->
    <div class="jf-goods bShadow-5">
      <div class="t">积分兑换</div>
      <div class="jf-g-wrapper">
        <div v-show="pointGoods.length === 0" class="order-none">
          <img src="@/assets/image/order_none.png" alt="">
          <p>暂无积分商品
          <p/>
        </div>
        <ul class="jf-g-list">
          <li class="jf-g-item" v-for="(item,index) in pointGoods" :key="index" @click="goGdsDetail(item)">
            <div class="jf-g-inner-w bShadow-10">
              <div class="jf-goods-img-w">
                <img :src="tImgUrl(item.image)" alt="" :onerror="errImgDefault">
              </div>
              <div class="jf-goods-name">{{item.name}}</div>
              <div class="point-btn-w">
                <div class="jf-p"><span class="p">{{item.price}}</span>分</div>
                <div class="btn-w">
                  <el-button type="success" class="redeem-btn" round mini @click="orderConfirm(item, event)">立即兑换</el-button>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- 积分规则 -->
    <!-- <el-dialog
        class="mp-rule-dia"
        ref="mpDialog"
        :visible.sync="pointRule"
        width="50%">
        <div class="mp-d-header" slot="title">
          积分规则
        </div>
        <div class="mp-d-content">
          如何获得积分？<br>
          登录App、每日签到、分享内容及邀请好友等操作都可以获取积分。获得的积分可以在积分商城中兑换优惠券、礼品卡以及调调精选好物等礼品。具体的积分规则及获得方式如下：<br>
          每日签到<br>
          连续签到第1天 - 第5天：每日签到积分+3<br>
          连续签到5天：额外获得15积分；<br>
          连续签到第6天 - 第30天：每日签到积分+5，<br>
          连续签到10天：额外获得20积分奖励；<br>
          连续签到20天：额外获得50积分奖励；<br>
          连续签到30天：额外获得100积分奖励；<br>
          连续签到第31天及以上：每日签到积分+10；<br>
          连续签到31天后每连续签到15天：额外100积分奖励；<br>
          当连续签到中断后，则回到初始签到状态重新累计连续签到天数；<br>
<br>
          邀请好友：<br>
          每邀请一名好友下载调调并成功输入你的邀请码，你与好友均可获得积分+25<br>
          当用户累计邀请5个好友的时候，可额外获得50积分的奖励；当累计邀请10个好友的时候，可再获得100积分的奖励；当邀请好友数超过10之后，每5个好友额外奖励50积分。<br>
<br>
          分享<br>
          每天成功将调调内容分享到其他平台：每次获得积分+3，最多3次<br>
<br>
          其他操作<br>
          新用户首次登录成功：赠送30积分<br>
          首次开启每日签到提醒：赠送20积分<br>
          首次在积分商城选择“心动好礼”，设为积分目标：赠送20积分<br>
          首次在积分商城兑换优惠码/礼品：赠送20积分<br>
          发表的评论变成精华评论时，可获得15积分的奖励<br>
        </div>
    </el-dialog> -->
    <!-- 积分规则 -->
    <agreement cateId="7" @agrShowHandler="agrShowHandler" :agShow="agShow" />
    <!-- 积分明细 -->
    <points-detail :visible="pointDetail" @visChg="updateDetailVis"></points-detail>
  </div>
</template>

<script>
import API from '@/api/usr-api'
import { mapGetters } from 'vuex'
import PointsDetail from '@/components/points-detail'
import Agreement from '@/components/agreement'

export default {
  name: 'mypoint',
  props: {},
  data () {
    return {
      pointGoods: [],
      point: 0,
      agShow: false,
      pointRule: false,
      pointDetail: false
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created () {

  },
  mounted () {

  },
  activated () {
    this.getMyPoint()
    this.getPointGoods()
  },
  deactivated () {

  },
  watch: {},
  methods: {
    agrShowHandler (v) {
      this.agShow = v
    },
    async getMyPoint () {
      const res = await API.getMyPoint({})
      this.point = res.data.result
      // console.log(res)
    },
    async getPointGoods () {
      const res = await API.getPointGoods({ currentPage: 1, pageSize: 12, cityCode: this.userInfo.cityCode })
      this.pointGoods = res.data.result.records
    },
    updateDetailVis (v) {
      this.pointDetail = v
    },
    goGdsDetail (i) {
      this.$router.push({ name: 'productDetail', params: { prodId: i.id } })
    },
    orderConfirm (i, e) {
      window.event ? window.event.cancelBubble = true : e.stopPropagation()
      this.$router.push({
        name: 'orderConfirm',
        params: {
          prodId: i.id
        }
      })
      e.stopPropagation()
    }
  },
  components: {
    PointsDetail, Agreement
  }
}
</script>

<style lang="stylus">
  .my-point
    .upper,.jf-goods
      background-color #ffffff
      box-sizing border-box

    .upper
      margin-bottom 20px
      padding 20px
      display flex
      position relative

      .uc-img
        flex 0 0 160px
        height 70px
        center()

        .uc-img-w
          height 70px
          width 70px
          font-size 0
          border-radius 50%
          overflow hidden

      // background-color green

      .info
        flex 0 0 320px
        height 70px
        line-height 70px

        .point
          color #999999
          font-size 18px
          padding-left 10px

          .num
            color theme-color
            font-size 18px
            padding 0px 12px 0px 8px

      .btn
        flex 1 1 auto
        flex-left()
        padding-left 100px
        box-sizing border-box

        .rules
          margin-left 60px

    .jf-goods
      .t
        height 50px
        line-height 50px
        box-sizing border-box
        padding-left 20px
        color #333333
        font-size 16px
        border-bottom 1px solid #dddddd

      .jf-g-wrapper
        height 486px
        box-sizing border-box
        padding 20px 7.5px

        .order-none
          width 100%
          text-align center
          padding-top 30px

        p
          color #dddddd

        .jf-g-list
          display flex
          flex-wrap wrap

          .jf-g-item
            padding 0 7.5px
            box-sizing border-box
            width 25%
            /*height 300px*/
            margin-bottom 15px

            .jf-g-inner-w
              padding 15px
              box-sizing border-box
              height 100%
              width 100%
              border-radius 5px
              border 1px solid #e5e5e5

              .jf-goods-img-w
                goods-img-wrapper()

                img
                  goods-img-image()

              .jf-goods-name
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
                text-align left
                color #333333
                font-size 18px
                height 26px
                line-height 26px
                margin 10px 0

              .point-btn-w
                flex-ltr-parent()

                .jf-p
                  color orange-color
                  font-size 16px
                  height 30px
                  line-height 30px
                  display flex

                  .p
                    dispaly inline-block
                    max-width 60px
                    overflow hidden
                    line-height 30px
                    text-overflow ellipsis
                    white-space nowrap
                    font-size 22px
                    padding-right 6px

                .btn-w
                  font-size 14px

                  .redeem-btn
                    height 30px
                    padding 0px 18px
                    line-height 30px
    .mp-rule-dia
      .mp-d-content
        overflow auto
        font-size 20px
        line-height 26px
</style>
